import type { HTMLAttributes } from 'react';

import React from 'react';

import { ArrowDownIcon, ArrowUpIcon, SortIcon } from '../../../icons';
import { classNames } from '../../../utils/class-names';

import styles from './table-header-cell.module.css';

export type SortOrder = 'asc' | 'desc';

export interface Sorting {
  order?: SortOrder;
  onSortingChange: () => void;
}

export type TableHeaderCellProps = {
  sorting?: Sorting;
} & HTMLAttributes<HTMLTableCellElement>;

/**
 * @param {Sorting} [sorting] - Object to define sort properties for a column
 * If `sorting` is given and no order is defined, a sort icon will be shown on hover.
 * If an order is defined the respective icon (arrow-up or arrow-down) is shown.
 */
export function TableHeaderCell({ id, sorting, children, className, ...props }: TableHeaderCellProps) {
  return (
    <th
      data-testid={id}
      onClick={() => sorting?.onSortingChange()}
      className={classNames(className, styles.headerCell)}
      {...props}
    >
      {sorting ? (
        <button className={classNames(styles.wrapper, styles.sortable)} data-testid="sortable-cell">
          {children}
          <div className={styles.icons}>
            {sorting.order === undefined && <SortIcon className={styles.hide} />}
            {sorting.order === 'asc' && <ArrowUpIcon />}
            {sorting.order === 'desc' && <ArrowDownIcon />}
          </div>
        </button>
      ) : (
        <div className={styles.wrapper} data-testid="not-sortable-cell">
          {children}
        </div>
      )}
    </th>
  );
}
